// @flow

import type { Node } from 'react';

type TProps = {
  setPopupContent: (N: Node) => void
};

export const Header = 'Total Ct. Wt.';

export function Content({ setPopupContent }: TProps) {
  return (
    <div>
      <p>
        The total carat weight of all diamonds within a particular accent group.
      </p>
    </div>
  );
}
